import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature, hasFeatureValue} from '../../../util/values';
import {selectHasBuriedBase, selectHeightDecided, selectIsOnesided, selectMeasures, selectModulePosPx, selectTotalHeightPx, selectIsBollard} from '../../../selectors';

@customElement('svg-productimage-single')
export class SvgProductimageSingle extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		justify-content: center;
		height: 100%;
		width: 100%;
	  }

	  svg {
		height: 100%;
		width: 100%;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.status = state.status;
	}

	render() {
		const moduleSize = getValueOfFeature('HS_ModuleCutoutSize_1', this.decisions) ?? 'M3';
		const reflectorColour = getValueOfFeature('LE_ReflectorColour_1', this.decisions) ?? 'Gold';
		const version = getValueOfFeature('LE_OpticalVersion_1', this.decisions) ?? 'Performance';
		let housingType = getValueOfFeature('HS_HousingType', this.decisions);
		if (housingType === 'WallSurface') {
			housingType = 'PoleLateral';
		}

		let offset = housingType === 'Bollard' ? -290 : 0;
		switch (moduleSize) {
			case 'M1':
				offset = 920;
				break;
			case 'M3':
			case 'M3F':
				offset = 757;
				break;
			case 'M6':
				offset = 482;
				break;
			case 'M12':
				offset = 30;
				break;
			default:
				offset = 0;
		}

		const svgPath = this.status.host + this.status.baseUrl + '/visuals/line-productimage-single.svg';
		return svg`
				<svg class="productimage-export" id="productimage-svg" xmlns="http://www.w3.org/2000/svg" width="639" height="2855" viewBox="0 0 639 2855"  xmlns:xlink="http://www.w3.org/1999/xlink">
					<g id="line-productimage-single" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(1047.5,1550.56) translate(-1427.5,-1550.56)">
						<g id="Housing" transform="translate(867.5,1550.56) translate(-1427.5,-1550.56)">
							<use href="${svgPath}#${housingType}_${moduleSize}"></use>
						</g>
						<g id="Modules" transform="translate(867,1429) translate(-150,-1147)">
							<use href="${svgPath}#${reflectorColour}_${moduleSize}_${version}" style="transform: translateY(${offset}px)"></use>
						</g>
					</g>
				</svg>`;
	}
}
